import { render, staticRenderFns } from "./CDNFiles.vue?vue&type=template&id=88bb8b80&"
import script from "./CDNFiles.vue?vue&type=script&lang=js&"
export * from "./CDNFiles.vue?vue&type=script&lang=js&"
import style0 from "./CDNFiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports